import { LatLng } from "@/models/core.model";

export const hk_lat_lng : LatLng = { 
    lat: Number(22.3193),
    lng: Number(114.1694) 
};